import { FC } from 'react'
import Icon from '@/root/ui/shared/Icon'
import { IconProps } from '@/root/shared-types/ui/ui-types'

export const BackIcon: FC<IconProps> = ({ width = 29, height = 24, ...rest }) => (
  <Icon type="Back" width={width} height={height} alt="back" {...rest} />
)
